module.exports = __webpack_public_path__ + "img/hu.95e64d2f.svg";